import { render, staticRenderFns } from "./msgCountDetails.vue?vue&type=template&id=1dc1fd6c&scoped=true&"
import script from "./msgCountDetails.vue?vue&type=script&lang=js&"
export * from "./msgCountDetails.vue?vue&type=script&lang=js&"
import style0 from "./msgCountDetails.vue?vue&type=style&index=0&id=1dc1fd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1fd6c",
  null
  
)

export default component.exports